module.exports = __webpack_public_path__ + "static/media/USAID-logo.c06b5fc7.svg";